import type {Tooltip as TooltipPrimitive} from 'flowbite-svelte';
import type {ComponentProps} from 'svelte';
import type {VariantProps} from 'tailwind-variants';
import {tv} from 'tailwind-variants';
import type {Class} from 'Catalyst/class';
import {default as Tooltip} from './Tooltip.svelte';

export const tooltipTvProps = tv({
  slots: {
    base: `
      max-w-[--tooltip-slots-base-max-width]
      rounded-[--tooltip-slots-base-border-radius]
      bg-[--tooltip-slots-base-surface]
      px-[--tooltip-slots-base-px]
      py-[--tooltip-slots-base-py]
      shadow-[--tooltip-slots-base-box-shadow]
      [font:--tooltip-slots-text-typography]
      !opacity-100
    `,
    label: `
      truncate
      font-[--tooltip-slots-text-font-weight]
      text-[--tooltip-slots-text-color]
    `,
  },
});

export type TooltipPrimitiveProps = ComponentProps<TooltipPrimitive>;

export type TooltipTVProps = VariantProps<typeof tooltipTvProps>;

export type TooltipOwnProps = Partial<{
  label: string;
}>;

export type TooltipProps = TooltipPrimitiveProps &
  TooltipTVProps &
  TooltipOwnProps &
  Class;

export {Tooltip};

export const DEFAULT_ARROW_SIZE = 7.07;
export const ONE_REM_IN_PX = 16;
